/**
 * 라우터 경로 정의
 *
 * NOTE: Vue 3 전환 시에도 재사용할 수 있도록 routes만 분리합니다.
 */
const routes = [
  {
    name: 'INDEX',
    path: '/',
    component: () => import('@/views/Index'),
    children: [
      {
        path: '/dashboard',
        component: () => import('@/views/dashboard/Dashboard'),
        meta: { auth: ['ADMIN'], isPro: false },
      },
      {
        path: '/home',
        component: () => import('@/views/home/Home'),
        meta: { auth: ['ADMIN', 'MEMBER'], isPro: false },
      },
      {
        path: '/home/project/detail',
        component: () => import('@/views/project/ProjectDetail'),
        meta: { auth: ['MEMBER'], isPro: false },
      },
      {
        path: '/home/container/detail',
        component: () => import('@/views/container/ContainerDetail'),
        meta: { auth: ['MEMBER'], isPro: false },
      },
      {
        path: '/home/volume/detail',
        component: () => import('@/views/volume/VolumeDetail'),
        meta: { auth: ['MEMBER'], isPro: false },
      },
      {
        path: '/project',
        component: () => import('@/views/project/Project'),
        meta: { auth: ['ADMIN'], isPro: false },
      },
      {
        path: '/project/detail',
        component: () => import('@/views/project/ProjectDetail'),
        meta: { auth: ['ADMIN'], isPro: false },
      },
      {
        path: '/container',
        component: () => import('@/views/container/Container'),
        meta: { auth: ['ADMIN'], isPro: false },
      },
      {
        path: '/container/detail',
        component: () => import('@/views/container/ContainerDetail'),
        meta: { auth: ['ADMIN'], isPro: false },
      },
      {
        path: '/container/detail/terminal',
        component: () => import('@/views/container/ContainerTerminal'),
        meta: { auth: ['ADMIN'], isPro: false },
      },
      {
        path: '/volume',
        component: () => import('@/views/volume/Volume'),
        meta: { auth: ['ADMIN', 'MEMBER'], isPro: false },
      },
      {
        name: 'VolumeDetail',
        path: '/volume/detail',
        component: () => import('@/views/volume/VolumeDetail'),
        meta: { auth: ['ADMIN', 'MEMBER'], isPro: false },
      },
      {
        path: '/training',
        component: () => import('@/views/training/Index'),
        redirect: '/training/scheduleJob',
        meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
      },
      {
        path: '/training/scheduleJob',
        component: () => import('@/views/training/ScheduleJob'),
        meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
      },
      {
        path: '/training/scheduleJob/detail',
        component: () => import('@/views/training/ScheduleJobDetail'),
        meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
      },
      {
        path: '/training/cronJob',
        component: () => import('@/views/training/CronJob'),
        meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
      },
      {
        path: '/training/cronJob/detail',
        component: () => import('@/views/training/CronJobDetail'),
        meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
      },
      {
        path: '/image',
        component: () => import('@/views/image/Image'),
        meta: { auth: ['ADMIN', 'MEMBER'], isPro: false },
      },
      {
        path: '/buildImage',
        component: () => import('@/views/management/BuildImage'),
        meta: { auth: ['ADMIN', 'MEMBER'], isPro: false },
      },
      {
        path: '/buildImage/detail',
        component: () => import('@/views/management/BuildImageDetail'),
        meta: { auth: ['ADMIN', 'MEMBER'], isPro: false },
      },
      {
        path: '/buildImage/create',
        component: () => import('@/views/management/BuildImageCreate'),
        meta: { auth: ['ADMIN'], isPro: false },
      },
      {
        path: '/workflow',
        component: () => import('@/views/workflow/Index'),
        redirect: '/workflow/workflow',
        meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
        children: [
          {
            path: 'workflow',
            component: () => import('@/views/workflow/Workflow'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'workflow/create',
            component: () => import('@/views/workflow/WorkflowCreate'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'workflow/detail',
            component: () => import('@/views/workflow/WorkflowDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'cronWorkflow',
            component: () => import('@/views/workflow/CronWorkflow'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'cronWorkflow/create',
            component: () => import('@/views/workflow/CronWorkflowCreate'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'cronWorkflow/detail',
            component: () => import('@/views/workflow/CronWorkflowDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'template',
            component: () => import('@/views/workflow/Template'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'template/detail',
            component: () => import('@/views/workflow/TemplateDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
        ],
      },
      {
        path: '/ml',
        component: () => import('@/views/mlflow/Index'),
        redirect: '/ml/dashboard',
        meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
        children: [
          {
            path: 'dashboard',
            component: () => import('@/views/mlflow/Dashboard'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'model',
            component: () => import('@/views/mlflow/Model'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'model/detail',
            component: () => import('@/views/mlflow/ModelDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'model/version/detail',
            component: () => import('@/views/mlflow/ModelVersionDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'serving',
            component: () => import('@/views/mlflow/Serving'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'serving/detail',
            component: () => import('@/views/mlflow/ServingDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'run',
            component: () => import('@/views/mlflow/Run'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'run/detail',
            component: () => import('@/views/mlflow/RunDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'flow',
            component: () => import('@/views/mlflow/Flow'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'flow/map',
            component: () => import('@/views/mlflow/Map'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'flow/detail',
            component: () => import('@/views/mlflow/FlowNodeDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'flow/hpo',
            component: () => import('@/views/mlflow/HpoWizard'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'flow/hpo-result',
            component: () => import('@/views/mlflow/HpoResult'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'flow/hpo-result/detail',
            component: () => import('@/views/mlflow/HpoResultDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'dataset',
            component: () => import('@/views/mlflow/Dataset'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'dataset/detail',
            component: () => import('@/views/mlflow/DatasetDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
        ],
      },
      {
        path: '/vision',
        component: () => import('@/views/vision/Index'),
        redirect: '/vision/dataset',
        meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
        children: [
          {
            path: 'dashboard',
            component: () => import('@/views/vision/Dashboard'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'dataset',
            component: () => import('@/views/vision/Dataset'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'dataset/:id',
            component: () => import('@/views/vision/DatasetDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'flow',
            component: () => import('@/views/vision/Flow'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'flow/:id',
            component: () => import('@/views/vision/FlowDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'flow/:id/initial',
            component: () => import('@/views/vision/InitialNodeDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'flow/:id/node/:nodeId',
            component: () => import('@/views/vision/NodeDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'flow/:id/node-editor/split',
            component: () => import('@/views/vision/SplitEditor'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'flow/:id/node-editor/:stage',
            component: () => import('@/views/vision/StageEditor'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'flow/:id/training/editor',
            component: () => import('@/views/vision/TrainingEditor'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'run',
            component: () => import('@/views/vision/Run'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'run/:id',
            component: () => import('@/views/vision/RunDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'model',
            component: () => import('@/views/vision/Model'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'model/:id',
            component: () => import('@/views/vision/ModelDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'serving',
            component: () => import('@/views/vision/Serving'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'serving/:id',
            component: () => import('@/views/vision/ServingDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
        ],
      },
      {
        path: '/app',
        component: () => import('@/views/app/Index'),
        redirect: '/app/catalog',
        meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
        children: [
          {
            path: 'catalog',
            component: () => import('@/views/app/Catalog'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'catalog/detail',
            component: () => import('@/views/app/CatalogDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'application',
            component: () => import('@/views/app/Application'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'application/detail',
            component: () => import('@/views/app/ApplicationDetail'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
          {
            path: 'repository',
            component: () => import('@/views/app/Repository'),
            meta: { auth: ['ADMIN', 'MEMBER'], isPro: true },
          },
        ],
      },
      {
        path: '/admission',
        component: () => import('@/views/admission/Admission'),
        meta: { auth: ['ADMIN'], isPro: false },
      },
      {
        path: '/request',
        component: () => import('@/views/request/Request'),
        meta: { auth: ['MEMBER'], isPro: false },
      },
      {
        path: '/management',
        component: () => import('@/views/management/Index'),
        redirect: '/management/configuration',
        meta: { auth: ['ADMIN'], isPro: false },
        children: [
          {
            path: 'user',
            component: () => import('@/views/management/User'),
            meta: { auth: ['ADMIN'], isPro: false },
          },
          {
            path: 'configuration',
            component: () => import('@/views/management/Configuration'),
            meta: { auth: ['ADMIN'], isPro: false },
          },
          {
            path: 'log',
            component: () => import('@/views/management/Log'),
            meta: { auth: ['ADMIN'], isPro: false },
          },
          {
            path: 'reports',
            component: () => import('@/views/management/Reports'),
            meta: { auth: ['ADMIN'], isPro: false },
          },
          {
            path: 'node',
            component: () => import('@/views/management/Node'),
            meta: { auth: ['ADMIN'], isPro: false },
          },
          {
            path: 'node/detail',
            component: () => import('@/views/management/NodeDetail'),
            meta: { auth: ['ADMIN'], isPro: false },
          },
        ],
      },
      {
        path: '/clusters',
        component: () => import('@/views/clusters/Clusters'),
        meta: { auth: ['ADMIN'], isPro: false },
      },
    ],
  },
  {
    name: 'COMPANY_DASHBOARD',
    path: '/company-dashboard',
    component: () => import('@/views/company-dashboard/CompanyDashboard'),
    meta: { auth: ['ADMIN', 'MEMBER'], isPro: false },
  },
  {
    name: 'CLUSTER',
    path: '/cluster',
    component: () => import('@/views/sessions/Cluster'),
    meta: { auth: ['ADMIN', 'MEMBER'], isPro: false },
  },
  {
    path: '/signin',
    component: () => import('@/views/sessions/SignIn'),
  },
  {
    path: '/signup',
    component: () => import('@/views/sessions/SignUp'),
  },
  {
    path: '/error',
    component: () => import('@/views/sessions/Error'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/error',
  },
]

export default routes
